import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1c5b0bc4&scoped=true"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=1c5b0bc4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5b0bc4",
  null
  
)

export default component.exports